export default {
  setProfileInfo(state, payload) {
    // console.log(
    //   "My paylod token",
    //   payload.token,
    //   payload.domain,
    //   payload.skills
    // );
    state.token = payload.token;
    state.uname = payload.uname;
    state.sessionLive = payload.sessionLive;
    state.permissions = payload.permissions;
    state.fullname = payload.fullname;
    state.phoneInfo = {
      exten: payload.exten,
      secret: payload.secret,
      pbxServer: payload.pbxServer,
      pbxPort: payload.pbxPort,
      stunURI: payload.stunURI,
      turnUser: payload.turnUser,
      turnPass: payload.turnPass,
      isAutoAnswer: payload.isAutoAnswer !== undefined ? payload.isAutoAnswer : false,
    };
    state.workPlace = payload.workPlace;
    state.workPhone = payload.workPhone;
    state.plugings = payload.plugings;
    state.usePhone = payload.usePhone;
    state.skills = payload.skills;
    state.domain = payload.domain;
    state.type = payload.type;
    state.status = payload.status;
    state.avatar = payload.avatar;
  },
  setStatus(state, payload) {
    state.status = payload.status;
  },
  setRestEndtime(state, payload) {
    state.restEndtime = payload;
  },

  setAvatar(state, payload) {
    state.avatar = payload;
  },

  setFullName(state, payload) {
    state.fullname = payload;
  },
  setSkills(state, payload) {
    state.skills = payload.skills;
    state.workPhone = payload.workPhone;
    state.workPlace = payload.workPlace;
  },
  setShortCodes(state, payload) {
    state.shortCodes = payload;
  },
  setSMSLogs(state, payload) {
    state.smsLogs = payload;
  },
  setProfile(state, payload) {
    state.profile = payload.profile;
  },
  setIncall(state, payload) {
    console.log("My inCall", payload);
    state.inCall = payload;
  },
  setIsConnected(state, payload) {
    state.isConnected = payload;
  },
  setCRMInitInfo(state, payload) {
    state.CRMInitInfo = payload;
  },
  setAnswerRequest(state, payload) {
    state.answerRequest = payload;
  },
  setHangupRequest(state, payload) {
    state.hangupRequest = payload;
  },
  setHoldRequest(state, payload) {
    state.holdRequest = payload;
  },
  setMuteRequest(state, payload) {
    state.muteRequest = payload;
  },
  setIsAnswered(state, payload) {
    state.isAnswered = payload;
  },
  setIsMute(state, payload) {
    state.isMute = payload;
  },
  setIsHolding(state, payload) {
    state.isHolding = payload;
  },
  setIsIncoming(state, payload) {
    state.isIncoming = payload;
  },
  setIsOutgoing(state, payload) {
    state.isOutgoing = payload;
  },
  setSessionPeer(state, payload) {
    state.sessionPeer = payload;
  },
  setCurrentCall(state, payload) {
    state.currentCall = payload;
  },
  setChatSocket(state, payload) {
    state.chatSocket = payload;
  },
  setSocketKey(state, payload) {
    state.socketKey = payload;
  },
  setIncomingSocketMessage(state, payload) {
    state.incomingSocketMessage = payload;
  },
  setIncomingSocketOmniMessage(state, payload) {
    state.incomingSocketOmniMessage = payload;
  },
  setCurrentChatID(state, payload) {
    state.currentChatID = payload;
  },
  setCurrentOmniID(state, payload) {
    state.currentOmniID = payload;
  },

  setNotReadChatMessages(state, payload) {
    state.notReadChatMessages = payload;
    // localStorage.setItem("chat-notify", payload);
  },
  setNotReadOmniMessages(state, payload) {
    state.notReadOmniMessages = payload;
  },
  setDifferentTABRead(state, payload) {
    state.differentTABRead = payload;
  },
  setOmniActiveConversations(state, payload) {
    state.omniActiveConversations = payload;
  },
  setOmniUsers(state, payload) {
    state.omniUsers = payload;
  },
  setOmniCloseOverlay(state, payload) {
    state.omniCloseOverlay = payload;
  },
  setOmniClosedCustomer(state, payload) {
    state.omniClosedCustomer = payload;
  },
  setHandleOpenedOmniConversation(state, payload) {
    state.handleOpenedOmniConversation = payload;
  },
  setOmniOpenedConversation(state, payload) {
    state.omniOpenedConversation = payload;
  },
  setOmniDifferentTABRead(state, payload) {
    state.omniDifferentTABRead = payload;
  },
  setOmniConversationClosed(state, payload) {
    state.omniConversationClosed = payload;
  },
  setAssignedOmniConversation(state, payload) {
    state.assignedOmniConversation = payload;
  },
  setDifferentTABSent(state, payload) {
    state.differentTABSent = payload;
  },
  setOmniDifferentTABSent(state, payload) {
    state.omniDifferentTABSent = payload;
  },
  setOmniFailedMsg(state, payload) {
    state.omniFailedMsg = payload;
  },
  setACWSettings(state, payload) {
    state.acwSettings = payload;
  },

  setACWStatus(state, payload) {
    state.acwStatus = payload;
  },
  setInAcw(state, payload) {
    state.inAcw = payload;
  },
  setNumberToCall(state, payload) {
    state.numberToCall = payload;
  },
  setCallsList(state, payload) {
    state.callsList = payload;
  },
  setCRMLocalFields(state, payload) {
    state.crmLocalFields = payload;
  },
  setTicketingLocalFields(state, payload) {
    state.ticketingLocalFields = payload;
  },
  setAssistantChat(state, payload) {
    state.assistantChat = payload;
  },
  setAssistantAsk(state, payload) {
    state.assistantAsk = payload;
  },
  setAutoAnswer(state, payload) {
    if (state.phoneInfo) {
      state.phoneInfo.isAutoAnswer = payload;
    }
  },
  setIsWhispering(state, payload) {
    state.isWhispering = payload;
  },
  setWhisperedAgent(state, payload) {
    state.whisperedAgent = payload;
  },
  setWhisperedChannel(state, payload) {
    state.whisperedChannel = payload;
  },
};
